import { Translate } from '@/shared/i18n';

export const TRIAL_RECORDING_MAX_SECONDS = 5 * 60;

export type RecordingFreeMinutes = { total: number; used: number };

export type TrialRecordingState = 'available' | 'used';

export const getTrialRecordingState = ({ total, used }: RecordingFreeMinutes): TrialRecordingState =>
  used > 0 || total - used <= 0 ? 'used' : 'available';

export const getTrialRecordingLeftPercent = (state: TrialRecordingState): number => (state === 'available' ? 100 : 0);

export const getTrialRecordingLabel = (state: TrialRecordingState, t: Translate): string =>
  state === 'available'
    ? t('records.credits.freeRecordingAvailable', { minutes: TRIAL_RECORDING_MAX_SECONDS / 60 })
    : t('records.credits.freeRecordingUsed');
